<!-- =========================================================================================
    File Name: TheFooter.vue
    Description: Footer component
    Component Name: TheFooter
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template functional>
  <footer class="the-footer flex-wrap justify-between" :class="classes">
    <vs-row vs-align="center" vs-type="flex" vs-justify="center" vs-w="12">
      <vs-col
        vs-align="center"
        vs-type="flex"
        vs-justify="center"
        vs-w="4"
        vs-sm="12"
      >
        <router-link to="/privacy-policy">Privacy Policy</router-link>
      </vs-col>
      <vs-col vs-align="center" vs-type="flex" vs-justify="center" vs-w="4">
      </vs-col>
      <vs-col
        vs-align="center"
        vs-type="flex"
        vs-justify="center"
        vs-w="4"
        vs-sm="12"
      >
        <vs-row vs-align="center" vs-type="flex" vs-justify="center" vs-w="12">
          <vs-col vs-w="1" vs-sm="2" vs-align="center" vs-justify="center">
            <a href="https://facebook.com/ballstar1" target="_blank"
              ><feather-icon svgClasses="text-hover-primary" icon="FacebookIcon"
            /></a>
          </vs-col>
          <vs-col vs-w="1" vs-sm="2" vs-align="center" vs-justify="center">
            <a href="https://twitter.com/_ballstar" target="_blank"
              ><feather-icon svgClasses="text-hover-primary" icon="TwitterIcon"
            /></a>
          </vs-col>
          <vs-col vs-w="1" vs-sm="2" vs-align="center" vs-justify="center">
            <a href="https://youtube.com/BallstarVideos" target="_blank"
              ><feather-icon svgClasses="text-hover-primary" icon="YoutubeIcon"
            /></a>
          </vs-col>
          <vs-col vs-w="1" vs-sm="2" vs-align="center" vs-justify="center">
            <a href="https://instagram.com/_ballstar" target="_blank"
              ><feather-icon
                svgClasses="text-hover-primary"
                icon="InstagramIcon"
            /></a>
          </vs-col>
          <vs-col vs-w="1" vs-sm="2" vs-align="center" vs-justify="center">
            <a href="mailto:info@ballstar.com" target="_blank"
              ><feather-icon svgClasses="text-hover-primary" icon="MailIcon"
            /></a>
          </vs-col>
        </vs-row>
      </vs-col>
    </vs-row>
    <vs-row vs-align="center" vs-type="flex" vs-justify="center" vs-w="12">
      <vs-col vs-w="3" vs-sm="6" class="text-right"
        >COPYRIGHT &copy; {{ new Date().getFullYear() }}&nbsp;</vs-col
      >
      <vs-col vs-w="3" vs-sm="6" class="text-left"
        >&nbsp;<a href="/" target="_blank" rel="nofollow">Ballstar </a> - All
        rights Reserved</vs-col
      >
    </vs-row>
  </footer>
</template>

<script>
export default {
  name: "the-footer",
  props: {
    classes: {
      type: String
    }
  }
};
</script>
